<template>
  <div class="wangjie">
      <div class="inner">
        <div class="inner-titles">
          <div class="pub-title" v-for="(item, index) in titles" :key="index" :class="{ active: activeTitle === index }" @click="dateClick(index)">
            <span>{{ $t(item) }}</span>
          </div>
        </div>
        <div class="inner-container">
          <waic-tabs :data="tabs" class="tabs" :active.sync="active"></waic-tabs>
          <div class="content" v-if="show">
            <liangdian v-if="active === 0" :data="liangdian"></liangdian>
            <jiabing v-if="active === 1" :yearUuid="timeuuid"></jiabing>
            <richeng v-if="active === 2" :yearUuid="timeuuid"></richeng>
            <jieshao v-if="active === 3" :data="jieshao"></jieshao>
            <xiazai v-if="active === 4" :data="reviewList"></xiazai>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import protal from "@/api/protal";
import liangdian from './liangdian';
import jiabing from './jiabing';
import richeng from './richeng';
import jieshao from './jieshao';
import xiazai from './xiazai';

export default {
  components: {
    liangdian,
    jiabing,
    richeng,
    jieshao,
    xiazai,
  },
  name: 'wangjie',
  data() {
    return {
      titles: [],
      tabs: ['wangjie1', 'wangjie2', 'wangjie3', 'wangjie4', 'download'],
      active: 0,
      activeTitle: 0,
      times: [],
      liangdian: {},
      jieshao: {},
      reviewList: [],
      forumDateList: [],
      imgList: [],
      show: true
    }
  },
  async activated() {
    await protal.getZdType('previous_year').then(res => {
      const arr = res.data || []
      this.times = arr.filter(x => x.lableValue !== 'hide')
      this.titles = this.times.map(x => x.lableDesc)
      this.times.forEach((x, i) => {
        if (x.lableDesc == this.$route.query.year) {
          this.activeTitle = i
          this.timeuuid = x.uuid
        }
      })
    })
    this.getAllData()
  },
  methods: {
    dateClick(index) {
      this.activeTitle = index
      this.timeuuid = this.times[this.activeTitle] && this.times[this.activeTitle].uuid
      this.getAllData()
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    getAllData() {
      this.getForumData()
      this.getData();
      this.getSpeakerType();
      this.getReviewList()
    },
    getReviewList() {
      protal.queryOfficialFileList({ fileType: 322, pageNum: 1, pageSize: 9999, yearUuid: this.timeuuid, showType: this.En ? 2 : 1 }).then(res => {
        if (res && res.data && res.data.length) {
          this.reviewList = res.data
        } else {
          this.reviewList = []
        }
      })
    },
    getData() {
      protal.queryPreviousReviewsList({ pageNum: 1, pageSize: 1, yearUuid: this.timeuuid }).then(res => {
        this.liangdian = res.data && res.data[0] || {}
          
        this.liangdian['content'] = this.liangdian['content'].replace(/<iframe.*?<\/iframe>/g, (x) => {
            const src = x.match(/src=\".*\"/)[0].slice(5, -1)
            return `<video @ended="endVideo('end')" src="${src}" controls></video>`
        })
        this.liangdian['contentEn'] = this.liangdian['contentEn'].replace(/<iframe.*?<\/iframe>/g, (x) => {
            const src = x.match(/src=\".*\"/)[0].slice(5, -1)
            return `<video @ended="endVideo('end')" src="${src}" controls></video>`
        })
      })
      protal.queryPreviousIntroductionList({ pageNum: 1, pageSize: 1, yearUuid: this.timeuuid }).then(res => {
        this.jieshao = res.data && res.data[0] || {}
          
        this.jieshao['content'] = this.jieshao['content'].replace(/<iframe.*?<\/iframe>/g, (x) => {
            const src = x.match(/src=\".*\"/)[0].slice(5, -1)
            return `<video @ended="endVideo('end')" src="${src}" controls></video>`
        })
        this.jieshao['contentEn'] = this.jieshao['contentEn'].replace(/<iframe.*?<\/iframe>/g, (x) => {
            const src = x.match(/src=\".*\"/)[0].slice(5, -1)
            return `<video @ended="endVideo('end')" src="${src}" controls></video>`
        })
      })
    },
    getForumData() {
      let params = {
        "pageNum": 1,
        "pageSize": 9999,
        "releaseSts": 0,
        "type": this.forumUuid,
        "yearDate": this.date,
        "yearUuid": this.timeuuid
      };
      protal.queryOfficialForumList(params).then((res) => {
        if (res && res.data) {
          this.forumDateList = res.data || [];
        } else {
          this.forumDateList = []
        }
      });
    },
    getSpeakerType() {
      // 获取会场导览图片
      protal.getZdCode("forum_img").then((res) => {
        if (res && res.data && res.data.length) {
          this.imgList = res.data;
        } else {
          this.imgList = []
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 769px) {
  .wangjie {
    padding: 1.65rem 0;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/page-bg.jpg);
    background-size: cover;

    .inner {
      width: 15.1rem;
      margin: 0 auto;

      .inner-titles {
        display: flex;
        justify-content: center;

        .pub-title {
          margin: 0 .3rem;
          font-size: .36rem;
          opacity: 0.6;
          cursor: pointer;

          &.active {
            opacity: 1;
          }
        }
      }
    }

    .content {
      width: 13.6rem;
      margin: .33rem auto 0;
    }

    .inner-container {
      margin-top: .45rem;
      background: #F6F7F7;
      border-radius: .16rem;
      padding: .42rem  0 .56rem;
    }
  }
}

/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .wangjie {
    padding: 1.46rem 0;
    background: url(https://static.worldaic.com.cn/2024/web/static/images/page-bg.jpg);
    background-size: cover;

    .inner {
      width: 7.1rem;
      margin: 0 auto;

      .inner-titles {
        display: flex;
        justify-content: center;

        .pub-title {
          margin: 0 .3rem;
          font-size: .36rem;
          opacity: 0.6;
          cursor: pointer;

          &.active {
            opacity: 1;
          }
        }
      }
    }

    .content {
      width: 100%;
      margin: .24rem auto 0;
    }

    .inner-container {
      margin-top: .45rem;
      background: #F6F7F7;
      border-radius: .16rem;
      padding: .42rem  .2rem .56rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/wangjie/index.vue